import HTTP from "../../../services/HTTP.js";

export const getResourceAllocations = async () => {
  const res = await HTTP.get('/resources-allocation');
  return res.data;
};
export const getResourceAllocationById = async (_id) => {
  const res = await HTTP.get(`/resources-allocation/${_id}`);
  return res.data;
};

// add ResourceAllocation
export const addResourceAllocation = async (data) => {
  const res = await HTTP.post('resources-allocation/add', data);
  return res.data;
};

// update password
export const updateResourceAllocation = async (data) => {
  const res = await HTTP.put('resources-allocation/update', data);
  return res.data;
};
// delete password
export const deleteResourceAllocation = async (id) => {
  const res = await HTTP.delete(`resources-allocation/delete/${id}`);
  return res.data;
};
